import type { ValidationError } from './validation';
import styles from './DeprecatedValidationErrorBanner.module.css';
import errorIcon from '@/assets/images/automation_error_icon.svg';

interface DeprecatedValidationErrorBannerProps {
  /** Validation error to display */
  error: ValidationError;
  /** Test ID for the container */
  'data-testid'?: string;
}

/**
 * Displays a validation error in a styled error box.
 * @deprecated - we're switching to little error labels below fields with
 * errors.
 */
export const DeprecatedValidationErrorBanner = ({
  error,
  'data-testid': testId,
}: DeprecatedValidationErrorBannerProps) => {
  return (
    <div className={styles.validationError} data-testid={testId}>
      <div className={styles.iconContainer}>
        <img src={errorIcon} alt='' className={styles.icon} />
      </div>
      <div className={styles.textContent}>
        <span className={styles.title}>{error.field}</span>
        <span className={styles.description}>{error.message}</span>
      </div>
    </div>
  );
};
